import { TextInput } from './text.mjs';
import { registerCustomElement } from '../utils.mjs';

export class EmailInput extends TextInput {}

registerCustomElement('imt-input-email', EmailInput);
